import Header from "./Header";
import PoweredBy from "./PoweredBy";
import { LocationIcon } from "../icons/LocationIcon";
import { Button } from "@nextui-org/react";

function LocationError({ desc, tryAgain, buttonText, onContinue, continueText }) {
  return (
    <div className="flex flex-col w-full h-full justify-between">
      <Header closeEnabled={false} />
      <div className="flex flex-col items-center gap-4 mb-10 p-10">
        <LocationIcon />
        <div className="desc">{desc}</div>
      </div>
      {(tryAgain || onContinue) && (
        <div className="flex flex-col items-center gap-3 p-10">
          {tryAgain && (
            <Button
              radius="sm"
              color="primary"
              className="w-full"
              onClick={() => tryAgain()}
            >
              {buttonText}
            </Button>
          )}
          {onContinue && (
            <Button
              radius="sm"
              variant="light"
              className="w-full"
              onClick={() => onContinue()}
            >
              {continueText || "Continue anyway"}
            </Button>
          )}
        </div>
      )}
      <div className="flex flex-row justify-center p-4">
        <PoweredBy />
      </div>
    </div>
  );
}

export default LocationError;
